import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const bezierConfig = { p0: 0.68, p1: -0.2, p2: 0.32, p3: 1.2 };
export const generalSolid = {
    version: 1,
    themeId: "general-solid",
    name: "General Solid",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/general-solid.webp`,
    background: [
        {
            variant: "geometric-blend",
            src: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/general-solid/geometricBlendBackground.jpg`,
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            durationSeconds: 5,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                startAtSeconds: 1,
                entrance: { variant: "squeeze-in", transitionDurationInFrames: 10 },
            },
            title: {
                fontFamily: "Oswald",
                fontSize: 170,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
            sceneBackground: {
                variant: "insetBox",
                padding: "2.5%",
                entranceVariant: "vertical-grow",
                entranceFrom: 30,
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "insetBox",
                padding: "2.5%",
            },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "insetBox",
                padding: "2.5%",
            },
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "",
            fontFamily: "Oswald",
            fontWeight: "light",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#0d1624",
                        backgroundOpacity: 0.75,
                    },
                ],
            },
            betweenTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: {
                    variant: "bezier",
                    config: bezierConfig,
                    durationSeconds: 1.25,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#AB977B",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#AB977B",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 0.95,
            borderRadius: "1.25rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "marginSlide",
            direction: "from-left",
            timing: {
                variant: "bezier",
                config: bezierConfig,
                durationSeconds: 1.25,
            },
        },
    },
    userInputFields: [
        {
            id: "colorPicker",
            type: "colorPicker",
            label: "Color",
            defaultValue: "Azure",
        },
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Thank You, Michael!",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 50,
            },
        },
    ],
    colorPalettes: [
        "Snow",
        "SunGlow",
        "Cantaloupe",
        "Blush",
        "Fandango",
        "Lilac",
        "CornflowerBlue",
        "Mint",
        "Lime",
        "Onyx",
        "Gold",
        "Rust",
        "Ruby",
        "DarkCherry",
        "Plum",
        "Azure",
        "Emerald",
        "Olive",
    ],
};
